/**
 * State and dependencies for API Loader
 * # ⛓️ CURSOR_ANCHOR:search:api-loader-state
 */

(function() {
  'use strict';

  window.SEARCH_RESULTS_API_LOADER_STATE = {
    getDeps: function() {
      return window.SEARCH_RESULTS_DEPS || {};
    },
    getState: function() {
      return window.SEARCH_RESULTS_STATE || {};
    },
    getFragmentBuilder: function() {
      return window.SEARCH_RESULTS_FRAGMENT || {};
    },
    getResultsCount: function() {
      return window.SEARCH_RESULTS_COUNT || {};
    }
  };
})();

